import { createContext } from "react";
import { Argument, ArgumentArray } from "classnames";

export type ThemeMode = "light" | "dark" | "blue";

export interface CustomThemeContextValue {
  customTheme: ThemeMode;
  setCustomTheme: (theme: CustomThemeContextValue["customTheme"]) => void;
  tcx: (
    ...args: Array<Argument | Partial<Record<ThemeMode, ArgumentArray>>>
  ) => string;
  darkMode: boolean;
  device: string | null;
  setDevice?: (e: string) => void;
}

export const CustomThemeContext = createContext<CustomThemeContextValue | null>(
  null
);
